/**
 * Customer Formatter.
 * @param {*} value
 * @param {object} row
 * @returns {string}
 */
window.customerFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="/admin/customers/show/'+row.customer_id+'">';
        html += value;
        html += '</a>';
    }
    return html;
}
